export default "__VITE_ASSET__CdS0nJ31__"